<div>
  <app-header-bar></app-header-bar>
</div>

<div class="integration-main-container">
  <app-integration-sidebar-button class="integration-sidebar"></app-integration-sidebar-button>
  <div class="integration-content">
    <mat-card class="integration-section">
      <h1>Integration Management</h1>
      <div class="integration-layers-card">
        <mat-form-field class="filter-form-field">
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="Search the name of the layer or repository."
            class="filter-input"
          />
        </mat-form-field>

        <mat-card-header class="integration-layers-header">
          <div class="section-title">
            <mat-icon mat-card-avatar>layers</mat-icon>
            <mat-card-title>Layers</mat-card-title>
          </div>

          <button
            matButton="filled"
            (click)="refreshLayersCloned()"
            matTooltip="Refresh all the repositories."
          >
            <mat-icon>
              @if (isLayersClonedLoading$()) {
                <mat-spinner diameter="24"></mat-spinner>
              } @else {
                refresh
              }
            </mat-icon>
            Refresh
          </button>

          <button
            matButton="filled"
            (click)="completeRepositoryClone()"
            matTooltip="Git clone a new repository."
          >
            <mat-icon>account_tree</mat-icon> <span>Clone</span>
          </button>
        </mat-card-header>
        <mat-card-content>
          <table
            mat-table
            [dataSource]="layersCloned$() || []"
            [trackBy]="trackBy"
            matSort
            (matSortChange)="onSortChange($event)"
          >
            <!-- Error Column -->
            <ng-container matColumnDef="layerError">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let layerCloned" class="layer-td">
                @if (layerCloned.errors?.length) {
                  <mat-icon [matTooltip]="layerCloned.errors.join('\n')" class="error-icon"
                    >warning</mat-icon
                  >
                }
              </td>
            </ng-container>
            <!-- Layer Name Column -->
            <ng-container matColumnDef="layerName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Layer Name</th>
              <td mat-cell *matCellDef="let layerCloned" class="layer-td">
                {{ layerCloned.layerName }}
              </td>
            </ng-container>

            <!-- Layer Type Column -->
            <ng-container matColumnDef="layerType">
              <th mat-header-cell *matHeaderCellDef>
                <div class="header-container">
                  <span>Layer Type</span>

                  <button
                    mat-icon-button
                    (click)="layerTypesSelect.open(); $event.stopPropagation()"
                  >
                    <mat-icon class="filter-type-icon">filter_list</mat-icon>
                  </button>
                  <mat-form-field class="layer-type-filter-form-field">
                    <mat-select
                      [formControl]="layerTypes"
                      multiple
                      (selectionChange)="onLayerTypeChange($event)"
                      #layerTypesSelect
                    >
                      @for (layerType of layersTypesOptions; track layerType) {
                        <mat-option [value]="layerType">{{ layerType }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let layerCloned" class="layer-td">
                <span
                  class="layer-type-span"
                  [class.raster-style]="layerCloned.layerType === 'Raster'"
                  [class.vector-style]="layerCloned.layerType === 'Vector'"
                  [class.tabular-style]="layerCloned.layerType === 'Tabular'"
                  [class.unknown-style]="layerCloned.layerType === 'Unknown'"
                >
                  {{ layerCloned.layerType }}
                </span>
              </td>
            </ng-container>

            <!-- Repository Name Column -->
            <ng-container matColumnDef="repoName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Repository Name</th>
              <td mat-cell *matCellDef="let layerCloned" class="layer-td">
                {{ layerCloned.repo }}
              </td>
            </ng-container>

            <!-- Integration Column -->
            <ng-container matColumnDef="integration">
              <th mat-header-cell *matHeaderCellDef>Integration Actions</th>
              <td mat-cell *matCellDef="let layerCloned">
                <div class="buttons-actions">
                  <button
                    matButton="outlined"
                    (click)="completeLayerIntegration(layerCloned.repo, layerCloned.layerType)"
                    [disabled]="layerCloned.errors?.length > 0"
                    matTooltip="Integrate the repository."
                  >
                    <mat-icon>layers</mat-icon>Layer Integration
                  </button>
                  <button
                    matButton="outlined"
                    (click)="openIntegrationLayerDetailed(layerCloned)"
                    [disabled]="layerCloned.errors?.length > 0"
                    matTooltip="View the integration history."
                  >
                    <mat-icon>history</mat-icon>Integration History
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Repository Actions</th>
              <td mat-cell *matCellDef="let layerCloned">
                <div class="buttons-actions">
                  <button
                    matButton="tonal"
                    (click)="completeRepositoryUpdate(layerCloned.repo)"
                    matTooltip="Git pull the repository."
                  >
                    <mat-icon>sync_arrow_down</mat-icon>Update
                  </button>
                  <button
                    matButton="tonal"
                    class="warn-button"
                    (click)="completeDeleteIntegration(layerCloned.repo, layerCloned.layerName)"
                    matTooltip="Delete the repository."
                  >
                    <mat-icon>delete</mat-icon>Delete
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          @if (layersCloned$()?.length === 0) {
            @if (filterValue$()) {
              <p class="no-data-info">No layer for this search.</p>
            } @else {
              <p class="no-data-info">No layer cloned.</p>
            }
          }
        </mat-card-content>
      </div>
    </mat-card>
  </div>
</div>
